<template>
    <MaltImg
        v-if="typeof props.svgIcon === 'string'"
        :alt="props.svgIcon"
        :src="`/navbar/icons/${props.svgIcon}.svg`"
        :height="svgSize"
        :width="svgSize"
        class="icon-img-wrapper"
    />
    <Component :is="props.svgIcon" v-else v-bind="props" />
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {commonIconProps} from '../icons/common-props';

    const props = defineProps({
        ...commonIconProps,
        // eslint-disable-next-line
        svgIcon: {},
    });
</script>
